import { get } from '../../utils/http';

export const fetchAuditLogs = ({ accountId, timesheetIds, jobIds, projectIds, employeeIds, token, pageSize }) =>
  get(`/accounts/${accountId}/audit-logs`, {
    timesheetIds,
    jobIds,
    pageSize,
    projectIds,
    employeeIds,
    token: token || 0
  });

export const exportAuditLogs = ({ accountId, timesheetIds, jobIds, projectIds, employeeIds, pageSize }) =>
  get(`/accounts/${accountId}/audit-logs/export`, {
    accountId,
    timesheetIds,
    jobIds,
    projectIds,
    employeeIds,
    pageSize
  });

export const fetchOSTimesheetAuditLogs = ({ accountId, timesheetId, token, pageSize }) =>
  get(`/accounts/${accountId}/timesheets/os/${timesheetId}/audit-logs`, {
    pageSize,
    token: token || 0
  });
